import { createTheme, type MantineColorsTuple } from '@mantine/core';
import { sunny, teal } from '@shared-ui-tokens/palettes';

/**
 * Portal theme — energy-forward palette tuned for 愛跳跳方塊 (and any
 * arcade / activity venue with similar "playful, physical" branding).
 *
 * Design decisions
 *   • PRIMARY — electric orange: warm, loud, arcade-cabinet energy.
 *   • ACCENT — teal: cool complement that reads "fresh".
 *   • Ramp values themselves live in @shared-ui-tokens/palettes so any
 *     marketing site / print / Figma export agrees on the exact hex.
 *
 * Staff console imports `navy` from the same source; portal only picks
 * different entries from the shared table.
 */
const sunnyRamp: MantineColorsTuple = [...sunny] as unknown as MantineColorsTuple;
const tealRamp: MantineColorsTuple = [...teal] as unknown as MantineColorsTuple;

export const portalTheme = createTheme({
  fontFamily: '"Noto Sans TC", sans-serif',
  primaryColor: 'sunny',
  // Shade 8 is the lightest sunny stop where white text on filled bg
  // meets AA (6.75:1). Shade 5 (former default) was 2.46:1 — failed.
  // See theme.contract.test.ts for the asserted pair.
  primaryShade: { light: 8, dark: 7 },
  colors: { sunny: sunnyRamp, teal: tealRamp },
  defaultRadius: 'lg',
  cursorType: 'pointer',
  headings: {
    fontFamily: '"Noto Sans TC", sans-serif',
    fontWeight: '700',
  },
});
